import React from "react";
import { connect } from "react-redux";
import { Icon, Message } from "semantic-ui-react";
import { MESSAGE_OPERACIONES_NO_DISPONIBLE } from "../../util/messageUtils";
import PropTypes from "prop-types";

const mapState = (state) => ({
  msgErrorServicioNoDisponible: state.pagoReducer.msgErrorServicioNoDisponible,
});

const ServicioNoDisponibleMessage = ({ msgErrorServicioNoDisponible }) => {
  return (
    <>
      <Message attached="bottom" size="small" color="blue">
        <Icon name="warning circle" />
        {msgErrorServicioNoDisponible
          ? msgErrorServicioNoDisponible
          : MESSAGE_OPERACIONES_NO_DISPONIBLE}
      </Message>
    </>
  );
};

ServicioNoDisponibleMessage.propTypes = {
  msgErrorServicioNoDisponible: PropTypes.string,
};

export default connect(mapState, null)(ServicioNoDisponibleMessage);
